import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {User} from './models/User';
import {SerializedUser} from './models/SerializedUser';
import {SerialziedCertificate} from './models/SerializedCertificate';
import {Certificate} from './models/certificate';
import {CertificateStatus} from './models/certificate-status.enum';
import {USERS} from './state';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  users: User[];
  currentUser: User = null;
  // currentUser: User = {
  //     id: '1',
  //     username: 'test',
  //     fullname: 'test',
  //     isProfessional: true,
  //     isInstitution: true,
  //     isCompany: true,
  //     pendingAccess: ['company@otentica.nl'],
  //     activeAccess: []
  //   };

  constructor(private router: Router) {
    // this.users = [
    //   {
    //     id: '2',
    //     username: 'professional@otentica.nl',
    //     fullname: 'Alice the Professional',
    //     isCompany: false,
    //     isInstitution: false,
    //     isProfessional: true,
    //     accessCode: 'rHa-x2eN-Apy',
    //     activeAccess: [],
    //     pendingAccess: []
    //   },
    //   {
    //     id: '3',
    //     username: 'company@otentica.nl',
    //     fullname: 'Bob the Business Owner',
    //     isCompany: true,
    //     isInstitution: false,
    //     isProfessional: false,
    //     activeAccess: [],
    //     pendingAccess: []
    //   },
    //   {
    //     id: '4',
    //     username: 'institution@otentica.nl',
    //     fullname: 'Claire the Teacher',
    //     isCompany: false,
    //     isInstitution: true,
    //     isProfessional: false,
    //     activeAccess: [],
    //     pendingAccess: []
    //   }
    // ]
    this.users = USERS.map(user => this.deserializeUser(user));
    this.users.push({
      id: '10002',
      username: 'professional@otentica.nl',
      fullname: 'Alice the Professional',
      isCompany: false,
      isInstitution: false,
      isProfessional: true,
      accessCode: 'rHa-x2eN-Apy',
      activeAccess: [],
      pendingAccess: [],
      certificates: []
    });
    this.users.push({
      id: '10003',
      username: 'company@otentica.nl',
      fullname: 'Bob the Business Owner',
      isCompany: true,
      isInstitution: false,
      isProfessional: false,
      activeAccess: [],
      pendingAccess: [],
      certificates: []
    });
    this.users.push({
      id: '10004',
      username: 'institution@otentica.nl',
      fullname: 'Claire the Teacher',
      isCompany: false,
      isInstitution: true,
      isProfessional: false,
      activeAccess: [],
      pendingAccess: [],
      certificates: []
    });
  }

  private deserializeUser(serializedUser: SerializedUser): User {
    return {
      id: "" + serializedUser.id,
      username: serializedUser.username,
      fullname: serializedUser.fullName,
      activeAccess: serializedUser.activeAccess,
      pendingAccess: serializedUser.pendingAccess,
      accessCode: serializedUser.accessCode,
      isInstitution: serializedUser.institution,
      isCompany: serializedUser.company,
      isProfessional: serializedUser.professional,
      companyName: serializedUser.companyName,
      certificates: serializedUser.certificates.map(certificate => this.deserializeCertificate(certificate, serializedUser))
    };
  }

  private deserializeCertificate(serializedCertificate: SerialziedCertificate, serializedUser: SerializedUser): Certificate {
    return  new Certificate({
      owner: "" + serializedUser.id,
      status: this.deserializeCertificateStatus(serializedCertificate.status),
      expiryDate: this.stringToDate(serializedCertificate.expiryDate),
      description: serializedCertificate.description,
      identifier: serializedCertificate.identifier,
      issuer: serializedCertificate.issuer
    });
  }

  private deserializeCertificateStatus(certificateStatus: string): CertificateStatus {
    switch(certificateStatus) {
      case "APPROVED": return CertificateStatus.APPROVED;
      case "PENDING_APPROVAL": return CertificateStatus.PENDING_APPROVAL;
      case "REJECTED": return CertificateStatus.REJECTED;
      case "EXPIRED": return CertificateStatus.EXPIRED;
    }
  }

  private stringToDate(date: string) : Date {
    return moment(date).toDate();
  }

  public login(username: string): boolean {
    let matchingUsers = this.users.filter(user => user.username === username);
    if(matchingUsers.length === 0) {
      return false;
    }
    this.currentUser = matchingUsers[0];
    return true;
  }

  public isLoggedIn(): boolean {
    return this.currentUser !== null;
  }

  public getUsername(): string {
    if(!this.isLoggedIn()) {
      return null;
    }
    return this.currentUser.username;
  }

  public getFullName(): string {
    if(!this.isLoggedIn()) {
      return null;
    }
    return this.currentUser.fullname;
  }

  public getCurrentUser(): User {
    return this.currentUser;
  }

  public isCompany(): boolean {
    if(!this.isLoggedIn()) {
      return false;
    }
    return this.getCurrentUser().isCompany;
  }

  public isProfessional(): boolean {
    if(!this.isLoggedIn()) {
      return false;
    }
    return this.getCurrentUser().isProfessional;
  }

  public isInstitution(): boolean {
    if(!this.isLoggedIn()) {
      return false;
    }
    return this.getCurrentUser().isInstitution;
  }

  public logout(): void {
    this.currentUser = null;
    this.router.navigate(['login']);
  }

  public getUserByAccessCode(accessCode: string): User {
    if(!accessCode)
      return null;
    let matchingUsers = this.users.filter(user => user.accessCode === accessCode);
    if(matchingUsers.length === 0) {
      return null;
    }
    return matchingUsers[0];
  }

  public getUserByUsername(username: string): User {
    if(!username)
      return null;
    let matchingUsers = this.users.filter(user => user.username === username);
    if(matchingUsers.length === 0) {
      return null;
    }
    return matchingUsers[0];
  }

  public getUserById(id: string): User {
    if(!id)
      return null;
    let matchingUsers = this.users.filter(user => user.id === id);
    if(matchingUsers.length === 0) {
      return null;
    }
    return matchingUsers[0];
  }

  public getAllUsers(): User[] {
    return this.users;
  }

}
